import { AcceptableDocumentCollectionRequestBuilder } from "./AcceptableDocumentCollectionRequestBuilder";
import { RequestBuilder } from "../RequestBuilder";

export class CatalogRequestBuilder extends RequestBuilder {
    public get acceptableDocuments() {
        return new AcceptableDocumentCollectionRequestBuilder(this._appendUrlSegment("acceptableDocuments"), this.client);
    }
}